module.exports = __webpack_public_path__ + "static/media/(H)_MG_6212_-_Joias_Contenporaneas.4f4c3120.jpg";